<template>
	<div class="tabWrapperSettings tabOffice">
		<main-table
				padding="0"
				:flag="flag"
				:headers="getHeaders"
				:listItems="officeOffice"
				@updateClickButton="onClickButton($event, flag)"
				:items-per-page-amount="10"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				@updateCreate="onCreate"
				text-create="Add new office"
				page-title="Office"
				:is-filter-refresh="false"
				:is-export="false"
				:is-search="false"
				:is-create="isCreate()"
		></main-table>

		<view-office
				v-if="isViewOffice"
				:dialogFlag="dialogFlag"
				:editOffice="editOffice"
				@updateSave="onSaveViewOffice"
				@updateClose="onCloseDialog('isViewOffice')"
				@updateList="onUpdateList('office')"
		></view-office>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</div>
</template>

<script>
import MainTable from "@/shared/MainTable/MainTable.vue";
import { tabOfficeTable, TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import ViewOffice from "@/components/Settings/UserAccountSettings/ViewOffice/ViewOffice.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";

import { mapActions, mapGetters } from "vuex";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "tabOffice",
	components: {
		DialogRemove,
		ViewOffice,
		MainTable
	},
	computed: {
		...mapGetters([
			'editOffice',
			'settingsOffice',
			'officeOffice',
			'filtersOffice',
			'permissionsDefault',
		]),
		getHeaders() {
			return tabOfficeTable;
		},
	},

	data: () => ({
		flag: TAB.OFFICE,

		isViewOffice: false,
		dialogFlag: null,
		nameComponent: null,
		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
	}),

	methods: {
		...mapActions([
			'getAccountOfficeList',
			'getAccountOfficeEdit',
			'deleteAccountOffice',
		]),

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_OFFICE, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateList(key) {
			if (key === 'office') {
				await this.getAccountOfficeList();
			}
		},

		onClickButton({ key, item }, nameComponent) {
			this.dialogFlag = 'edit';
			this.nameComponent = nameComponent;
			this.activeItem = item;

			if (nameComponent === 'tabOffice' && key === 'edit1') {
				this.accountOfficeEdit();
			}
			if (nameComponent === 'tabOffice' && key === 'delete1') {
				const title = TITLE.REMOVE_OFFICE;
				const text = TEXT.REMOVE_OFFICE;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'tabOffice') {
				const { office_id } = this.activeItem;
				await this.deleteAccountOffice(office_id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		async accountOfficeEdit() {
			const { office_id } = this.activeItem;
			await this.getAccountOfficeEdit(office_id);
			this.isViewOffice = true;
		},
		onCreate() {
			this.dialogFlag = 'add';
			this.isViewOffice = true;
		},
		onSaveViewOffice(args) {
			console.info('%c [ onSaveViewOffice args  ] ', 'color:#bada55', typeof args, args );
		},
		onCloseDialog(key) {
			this[key] = false;
		},
	},
	async mounted() {
		await this.getAccountOfficeList();
	}
};
</script>

<style scoped lang="scss">
@import "tabWrapperSettings";
</style>

